module.exports = __webpack_public_path__ + "media/bootstrap-icons/camera2-7bdf8d84.svg";